import { render, staticRenderFns } from "./JudicialMetadataPage.vue?vue&type=template&id=249349d2"
import script from "./JudicialMetadataPage.vue?vue&type=script&lang=js"
export * from "./JudicialMetadataPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports